module.exports=[
    {
        "object": "Jackhammer",
        "decibel": 130,
        "display": "130 dB",
        "plane": "no"
    },
    {
        "object": "Rock/pop concert",
        "decibel": 115,
        "display": "110-120 dB",
        "plane": "no"
    },
    {
        "object": "Super Hornet plane",
        "decibel": 110,
        "display": "101-119 dB*",
        "plane": "yes"
    },
    {
        "object": "Hornet plane",
        "decibel": 106.5,
        "display": "95-118 dB*",
        "plane": "yes"
    },
    {
        "object": "Motorcycle",
        "decibel": 100,
        "display": "100 dB",
        "plane": "no"
    },
    {
        "object": "Electric vacuum",
        "decibel": 80,
        "display": "80 dB",
        "plane": "no"
    },
    {
        "object": "Average office noise",
        "decibel": 70,
        "display": "70 dB",
        "plane": "no"
    },
    {
        "object": "Average room noise",
        "decibel": 40,
        "display": "30-50 dB",
        "plane": "no"
    }
]
